import styled from "styled-components"
// import theme from "../../../../../../../../res/theme.js"

export const ButtonsContainer = styled.div`
  display: block;
`
